import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PermissionSetsModel } from '../views/models/permission-sets.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  record_change$ = new BehaviorSubject<PermissionSetsModel>(undefined);

  constructor(private httpClient: HttpClient) {
  }

  getPermissionSetByID(userId: number) {
    return this.httpClient.get(environment.baseURL + '/v2/api' + '/permission_set_byid/' + userId);
  }

  getPermissionSet(userID: number): Promise<PermissionSetsModel[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/permission_set_byid/' + userID).subscribe({
        next: (data: PermissionSetsModel[]) => {
          resolve(data);
        },
        error: error => {
          reject(error);
        }
      });
    });
  }

}
